import { Box, Table, TableBody, TableCell, TableRow, Typography } from '@mui/material';
import { Order, Settlement } from '../../../Models';
import { historyPriceFormatter } from '../../../utils/formatters';

type PaymentInfoSectionProps = {
    order: Order;
    settlement: Settlement;
};
export default function PaymentInfoSection({ order, settlement }: PaymentInfoSectionProps) {
    const productsTotal = settlement.products.total_price / 100;
    const shippingTotal = settlement.shipping.total_charged_price / 100;
    const shippingDiscount = settlement.shipping.discount_pct;
    const total = settlement.total_charged_amount / 100;
    const delfarNominalFee = settlement.delfar_fees.nominal_sales_fee / 100;
    const delfarShippingFee = settlement.delfar_fees.nominal_shipping_fee / 100;
    return (
        <Box>
            <Typography variant="subtitle1" gutterBottom>
                💰 Ingresos
            </Typography>
            <Table size="small">
                <TableBody>
                    <TableRow sx={{ '& > td': { borderBottom: 'none' } }}>
                        <TableCell>Products</TableCell>
                        <TableCell align="right">
                            $ {historyPriceFormatter.format(productsTotal)}
                        </TableCell>
                    </TableRow>
                    <TableRow sx={{ '& > td': { borderBottom: 'none' } }}>
                        <TableCell>
                            Envío {shippingDiscount ? `con ${shippingDiscount}% descuento` : null}
                        </TableCell>
                        <TableCell align="right">
                            $ {historyPriceFormatter.format(shippingTotal)}
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Total ingresado</TableCell>
                        <TableCell align="right">$ {historyPriceFormatter.format(total)}</TableCell>
                    </TableRow>
                    <TableRow sx={{ '& > td': { borderBottom: 'none' } }}>
                        <TableCell>Venta con Delfar</TableCell>
                        <TableCell align="right">
                            - $ {historyPriceFormatter.format(delfarNominalFee)}
                        </TableCell>
                    </TableRow>
                    <TableRow sx={{ '& > td': { borderBottom: 'none' } }}>
                        <TableCell>Envío con Delfar</TableCell>
                        <TableCell align="right">
                            - $ {historyPriceFormatter.format(delfarShippingFee)}
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </Box>
    );
}
